export default __webpack_public_path__ + "static/media/ESSK34AMET01_1920x1080.41f5ef7b.jpg";